import styled from 'styled-components';

import {
  spacingInlineXxs,
  spacingInlineSm,
} from '@useblu/ocean-tokens/web/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & .ods-typography {
    text-align: center;
  }

  & .ods-typography__heading3 {
    margin: ${spacingInlineSm} 0 ${spacingInlineXxs};
  }
`;

export const Image = styled.img``;
